import React, {PropTypes} from 'react';
import Button from '../common/Button';
import '../../styles/dashboard/dashboardOptionButton.css';

const DashboardOptionButton = ({text, path, helpText, outlinedButton, onClick}) => {
  if (outlinedButton === true) {
    return (
      <div className="row">
        <Button
          onClick={onClick}
          value={text}
          disabled={false}
          className={'dashboard-option-button outlined-button btn btn-default col-sm-6'}
          name={path}/>
        <div className="button-help col-sm-6 col-xs-12">
          {helpText}
        </div>
      </div>
    );
  } else {
    return (
      <div className="row">
        <Button
          onClick={onClick}
          value={text}
          disabled={false}
          className={'dashboard-option-button btn btn-default col-sm-6'}
          name={path}/>
        <div className="button-help col-sm-6 col-xs-12">
          {helpText}
        </div>
      </div>
    );
  }
};

DashboardOptionButton.propTypes = {
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  outlinedButton: PropTypes.bool,
  helpText: PropTypes
    .oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  onClick: PropTypes.func.isRequired
};

export default DashboardOptionButton;



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DashboardOptionButton.js
 **/